import { THEMES } from 'Constants/bundles';
import { setItem as setSessionItem, getItem as getSessionItem } from 'Helpers/sessionStorage';
import { EXPONEA_EVENT_TO_KEY_MAP } from 'Constants/exponeaLeads';
import { CTAS_ACTION } from 'Constants/constants';
import trackingEvents from 'Constants/trackingEvents';

/**
 * Check if lead has already been created & adId exists in the session storage
 * @param { String } adId
 * @returns { Boolean }
 */
export const getSubmittedLeadStatus = adId => {
    let itemToLeadsMapping = getSessionItem(EXPONEA_EVENT_TO_KEY_MAP.b2c_carSubmitLead);
    const sessionKey = adId || '';

    itemToLeadsMapping = (itemToLeadsMapping) ? JSON.parse(itemToLeadsMapping) : {};
    return sessionKey in itemToLeadsMapping;
};

/**
 * Update submitted lead status in the session storage
 * @param { String } adId
 */
export const updateSubmittedLeadStatus = adId => {
    let itemLeadMap = getSessionItem(EXPONEA_EVENT_TO_KEY_MAP.b2c_carSubmitLead);

    itemLeadMap = (itemLeadMap) ? JSON.parse(itemLeadMap) : {};
    if (adId) {
        itemLeadMap[adId] = true;
        setSessionItem(EXPONEA_EVENT_TO_KEY_MAP.b2c_carSubmitLead, JSON.stringify(itemLeadMap));
    }
};

export const getMarketConfigForOptimus = marketConfig => {
    const countryCode = marketConfig.get('login', 'countryCode');
    const lang = marketConfig.get('lang');
    const theme = marketConfig.get('theme', 'id') || THEMES.OLX;
    const staticAssetsUrl = marketConfig.get('staticAssets');

    return ({
        countryCode,
        lang,
        theme,
        staticAssetsUrl
    });
};

export const getCtaName = (action, isStoreVisitEnabled = false) => {
    const { onInterestedTap, assitiveChatOnTabCallBack, chatWindowOnTapMeeting, onNotifyMeTap } = CTAS_ACTION;
    const ctaNameLookup = {
        [onInterestedTap]: trackingEvents.iAmInterested,
        [assitiveChatOnTabCallBack]: trackingEvents.requestCallBack,
        [chatWindowOnTapMeeting]: isStoreVisitEnabled ? trackingEvents.storeVisit : trackingEvents.testDrive,
        [onNotifyMeTap]: trackingEvents.notifyMe
    };

    return ctaNameLookup[action] || null;
};
